var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "previous",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.007,
    height: 29.708,
    viewBox: "0 0 32.007 29.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M.48,103.773A1.649,1.649,0,0,0,0,104.934a1.632,1.632,0,0,0,.48,1.161L13.686,119.3a1.648,1.648,0,1,0,2.331-2.331L5.611,106.584H30.357a1.645,1.645,0,1,0,0-3.29H5.611l10.4-10.406a1.648,1.648,0,0,0-2.331-2.331Z",
    transform: "translate(0 -90.075)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.81a4cf1d2bc051195f17485c6b722bca.svg";
export { ForwardRef as ReactComponent };